import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="deals-filter"
export default class extends Controller {
  static targets = [
    "panel",
    "categoryInput",
    "categoryButton",
    "priceInput",
    "priceLabel",
    "radiusInput",
    "radiusLabel",
    "mainForm", // Target to submit the form after resetting
  ];

  connect() {
    this.updatePriceLabel();
    this.updateRadiusLabel();
  }

  toggle() {
    this.panelTarget.classList.toggle("hidden");
  }

  // Handle Category Button Clicks
  selectCategory(event) {
    const selectedValue = event.currentTarget.dataset.value;
    this.categoryInputTarget.value = selectedValue;
    this.updateCategoryVisuals(selectedValue);
  }

  updateCategoryVisuals(selectedValue) {
    this.categoryButtonTargets.forEach((btn) => {
      if (btn.dataset.value === selectedValue) {
        btn.classList.replace("bg-white", "bg-gray-900");
        btn.classList.replace("text-gray-700", "text-white");
      } else {
        btn.classList.replace("bg-gray-900", "bg-white");
        btn.classList.replace("text-white", "text-gray-700");
      }
    });
  }

  updatePriceLabel() {
    this.priceLabelTarget.textContent = `Price Range: 0 - ${this.priceInputTarget.value}`;
  }

  updateRadiusLabel() {
    this.radiusLabelTarget.textContent = `Radius: ${this.radiusInputTarget.value} km`;
  }

  // --- NEW: Global Reset Function ---
  reset(event) {
    // 1. Reset Category
    this.categoryInputTarget.value = "";
    this.updateCategoryVisuals(""); // Visual reset to 'All'

    // 2. Reset Price (Assuming max is 20000)
    this.priceInputTarget.value = "20000";
    this.updatePriceLabel();

    // 3. Reset Radius (Assuming default is 50)
    this.radiusInputTarget.value = "50";
    this.updateRadiusLabel();

    // 4. Submit the form to refresh results (Optional: remove if you don't want auto-submit)
    // We use requestSubmit() so it triggers the Turbo stream
    document.getElementById("deals-search-form").requestSubmit();
  }
}
